'use strict';

var Backbone = require('backbone'),
  $ = require('jquery'),
  mediator = require('mediatorjs'),
  config = require('../config'),
  _ = require('underscore');
import EllipsisView from '../../components/Ellipsis/EllipsisView';
let filterTags = $('#filterTags');

const TagFilterView = Backbone.View.extend({

  // Maximum number of tags to show on mobile
  tagNumberLimit: 12,

  // Tag height in pixel, from _tag-filters.scss
  tagHeight: 50,

  // Number of new lines of tags to show on every click on Load More
  moreToShow: 6,

  // List of breakpoint on which the load more should be hidden
  hideLoadMoreBreakpoint: [
    config.events.breakpoint.tablet,
    config.events.breakpoint.laptop,
    config.events.breakpoint.desktop,
    config.events.breakpoint.wide
  ],

  events: {
    'click .TagFilter-tags-loadMore': 'onLoadMoreClick',
    'click .TagFilter-tag:not(.TagFilter-clear)': 'onTagClick',
    'click .TagFilter-clear': 'onClearTagClick',
    'click .TagFilter-filter': 'onFilterClick',
    'click .right-paddle': 'rightSwiping',
    'click .left-paddle': 'leftSwiping'
  },

  initialize: function() {
    this.$tagsList = this.$('.TagFilter-tags');
    this.$tags = this.$('.TagFilter-tag');
    this.$filters = this.$('.TagFilter-filter');
    this.$loadMore = this.$('.TagFilter-tags-loadMore');
    this.$itemsLength = this.$('.item').length;
    this.$itemSize = this.$('.item').outerWidth(true);
    this.$leftPaddle = this.$('.left-paddle');
    this.$rightPaddle = this.$('.right-paddle');

    // Initialize filter id and tag ids with initial ones
    this.filterId = this.$('.TagFilter-filter.' + config.classes.isActive).data('filterid');
    this.tagIds = this.$('.TagFilter-tag.' + config.classes.isActive).map(function() {
      return $(this).data('tagid');
    }).toArray();

    // Create an ellipsis view for each tag to make sure it's not too high, which would break the layout
    if (this.$tags.length) {
      new EllipsisView(this.$tags, {
        height: this.tagHeight
      });
    }

    // When the number of tags is greater than the maximum number or tags to show, initialize loadMore
    if (this.$tags.length > this.tagNumberLimit) {
      this.initializeLoadMore();
    }

    this.hideRightArrow();

    this.$('.menu').on('scroll', () => {
      this.hideLeftRightArrow()
    })
  },

  hideRightArrow: function() {
    this.$itemsLength = this.$('.item').length;
    var menuSize = this.$itemsLength * this.$itemSize;
    var menuVisibleSize = this.$('.menu').width();
    if (menuSize > menuVisibleSize) {
      this.$rightPaddle.removeClass('hidden');
    }
  },

  initializeLoadMore: function() {
    this.$el.addClass(config.classes.hasLoadMore);
    this.maxTagListHeight = this.tagHeight * Math.ceil(this.$tags.length / 2);

    // Hide load more on those breakpoints
    mediator.on(this.hideLoadMoreBreakpoint.join(' '), _.bind(this.hideLoadMore, this));
  },

  // When load more should be hidden
  hideLoadMore: function() {
    // Remove inline height set by every click on Load More
    this.$tagsList.css('height', '');
    this.$loadMore.removeClass(config.classes.isHidden);
  },

  // On each click on Load More button
  onLoadMoreClick: function() {

    // If Load More is not initialized or every tags are already shown, return
    if (!this.$el.hasClass(config.classes.hasLoadMore) || this.$loadMore.hasClass(config.classes.isHidden)) return;

    // Increment list height by the number of additional elements to show
    var newHeight = this.$tagsList.outerHeight() + this.moreToShow * this.tagHeight;

    if (newHeight < this.maxTagListHeight) {
      // When the new height doesn't reach the maximum
      this.$tagsList.css('height', newHeight);

    } else {
      // When the new height reaches the maximum
      this.$tagsList.css('height', this.maxTagListHeight);
      this.$loadMore.addClass(config.classes.isHidden);
    }

  },

  // When a preset filter is clicked
  onFilterClick: function(e) {
    var $filter = $(e.currentTarget);
    if ($filter.hasClass(config.classes.isActive)) {
      // If the clicked filter is already selected, unselect it
      $filter.removeClass(config.classes.isActive);
      $filter.attr('aria-current',false);
      this.filterId = null;
    } else {
      // If the clicked filter is not selected, set it active and remove active state from others (there should be only one filter active at a time)
      this.$filters.removeClass(config.classes.isActive);
      $filter.addClass(config.classes.isActive);
      $filter.attr('aria-selected',true);
      $filter.attr('aria-current',true);
      this.filterId = $filter.data('filterid');
    }

    this.trigger('change', 'filter', this.filterId, this.tagIds);
    if (filterTags.length) {
      $('html,body').animate({scrollTop: filterTags.offset().top},'slow');
    }
  },

  onCustomTagClick: function(e) {
    if ($(e.currentTarget).hasClass(config.classes.isActive)) {
      return;
    }
    this.onClearTagClick();
  },
  // When a tag is clicked
  onTagClick: function(e) {
    if (e.target.parentNode && e.target.parentNode.classList.contains('si-tabBorder')) {
      this.$tags.removeClass(config.classes.isActive);
      this.$tags.attr('aria-current',false);
      this.tagIds = [];
    } else {
      this.onClearTagClick();
    }
    var $tag = $(e.currentTarget),
      tagId = $tag.data('tagid');
    if ($tag.hasClass(config.classes.isActive)) {
      // If the tag is already active, remove class and remove it from the array
      $tag.removeClass(config.classes.isActive);
      $tag.attr('aria-selected',false);
      $tag.attr('aria-current',false);
      this.tagIds = _.without(this.tagIds, tagId);

    } else {
      // If tag is not already active add class and push it to the array
      $tag.addClass(config.classes.isActive);
      $tag.attr('aria-selected',true);
      $tag.attr('aria-current',true);
      this.tagIds.push(tagId);
    }

    this.trigger('change', 'tag', this.filterId, this.tagIds);
    if (filterTags.length) {
      $('html,body').animate({scrollTop: filterTags.offset().top},'slow');
    }
  },

  // When the clear filter button is clicked
  onClearTagClick: function() {
    this.$tags.removeClass(config.classes.isActive);
    this.$tags.attr('aria-current',false);
    this.tagIds = [];
    this.trigger('change', 'tag', this.filterId, this.tagIds);
    if (filterTags.length) {
      $('html,body').animate({scrollTop: filterTags.offset().top},'slow');
    }
  },

  rightSwiping() {
    this.$itemsLength = this.$('.item').length;
    var menuSize = this.$itemsLength * this.$itemSize;
    var menuVisibleSize = this.$('.menu').width();
    var menuInvisibleSize = menuSize - menuVisibleSize;
    var scrollableContentSize = menuInvisibleSize - this.$('.menu').scrollLeft();
    if (scrollableContentSize > menuVisibleSize) {
      $('.menu').animate({ scrollLeft: '+=' + menuVisibleSize}, 300);
    } else {
      $('.menu').animate({ scrollLeft: '+=' + menuInvisibleSize}, 300);
    }
  },

  leftSwiping() {
    var menuWrapperSize = this.$('.menu-wrapper').width() || this.$('.menu-wrapper').prevObject.width();
    var menuVisibleSize = this.$('.menu').width();
    var currentScrollPosition = this.$('.menu').scrollLeft();
    if (currentScrollPosition > menuWrapperSize && currentScrollPosition > menuVisibleSize) {
      $('.menu').animate({ scrollLeft: '-=' + menuVisibleSize}, 300);
    } else {
      $('.menu').animate({ scrollLeft: 0}, 300);
    }
  },

  hideLeftRightArrow() {
    this.$itemsLength = this.$('.item').length;
    var paddleMargin = 20
    var menuSize = this.$itemsLength * this.$itemSize;
    var menuVisibleSize = this.$('.menu').width();
    var menuInvisibleSize = menuSize - menuVisibleSize;
    // get how much have we scrolled so far
    var menuPosition = this.$('.menu').scrollLeft();
    var menuEndOffset = menuInvisibleSize - paddleMargin;
    var menuWrapperSize = this.$('.menu-wrapper').width() || this.$('.menu-wrapper').prevObject.width();
    if (menuWrapperSize >= 768 && menuWrapperSize < 1024 && menuPosition > menuWrapperSize) {
      menuPosition = this.$('.menu').scrollLeft() + (menuSize - this.$('.menu').prop('scrollWidth'))
    }
    // show & hide the paddles
    // depending on scroll position
    if (menuPosition <= paddleMargin) {
      this.$leftPaddle.addClass('hidden');
      this.$rightPaddle.removeClass('hidden');
    } else if (menuPosition < menuEndOffset) {
      // show both paddles in the middle
      this.$leftPaddle.removeClass('hidden');
      this.$rightPaddle.removeClass('hidden');
    } else if (menuPosition >= menuEndOffset) {
      this.$leftPaddle.removeClass('hidden');
      this.$rightPaddle.addClass('hidden');
    }
  }
});

module.exports = TagFilterView;



// WEBPACK FOOTER //
// ./assets/js/components/TagFilterView.js